import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgForOf } from '@angular/common';
import { NumbersOnlyDirective } from '../../directives/number-valitiation/numbers-only.directive';
import { FormsModule } from '@angular/forms';
import { CountryCodes } from "../../../core/constants/country-codes";

@Component({
  selector: 'app-mobile-number',
  standalone: true,
  templateUrl: './mobile-number.component.html',
  imports: [
    NgClass,
    NgForOf,
    NumbersOnlyDirective,
    FormsModule
  ],
  styleUrls: ['./mobile-number.component.scss']
})
export class MobileNumberComponent {
  @Input() Max: number = 10;
  @Input() Touched: boolean | null = null;
  @Input() Disabled: boolean | null = null;
  @Input() set Number(contactNumber: string | null) {
    if (contactNumber && contactNumber.length > 0) {
      this.number = contactNumber;
      this.splitNumberAndCountry();
    }
  }

  @Output() OnChange: EventEmitter<string | null> = new EventEmitter<string | null>();

  defaultText = 'Country';
  dropdownText: string = this.defaultText;
  countryCode: string | null = null;
  number: string = '';
  maxLength: string = `${this.Max}.0`;
  countryCodes = CountryCodes;
  defaultClass = 'fi fi-nl';
  class: string | null = null; // determines the flag that is shown in the dropdown
  originalNumber: string | null = null;

  splitNumberAndCountry() {
    if (this.number) {
      this.originalNumber = this.number;
      this.number = this.number.trimStart();
      this.tryGetCountryCode();
      this.splitNumber();
    } else {
      this.number = '';
    }
  }

  tryGetCountryCode() {
    // try to find the country code
    const code = this.number.substring(0, this.number.indexOf(' '));
    const country = CountryCodes.find(x => x.code === code);
    if (country) {
      this.setCountryCode(country.code, country.iso, false);
    }
  }

  splitNumber() {
    // set the number after the country code
    this.number = this.number.substring(this.number.indexOf(' ') + 1);
    this.formatNumber();
    // emit the change
    if (this.originalNumber !== `${this.countryCode} ${this.number}`) {
      this.emitOutput();
    }
  }

  formatNumber() {
    this.number = this.number.replaceAll('.', '');
    this.number = this.number.replaceAll('+', '');
    this.number = this.number.replaceAll(' ', '');
    this.number = this.number.replaceAll('-', '');
    this.number = this.number.replaceAll('(', '');
    this.number = this.number.replaceAll(')', '');
  }

  setCountryCode(code: string, iso: string, emit: boolean) {
    this.dropdownText = code;
    this.class = `fi fi-${iso}`;
    this.countryCode = code;
    if (emit) {
      this.emitOutput();
    }
  }

  emitOutput() {
    // only emit if both are set or cleared
    if ((this.countryCode && this.number)) {
      this.OnChange.emit(`${this.countryCode} ${this.number}`);
    } else if ((!this.countryCode && !this.number)) {
      this.OnChange.emit(null);
    }
  }

  clear() {
    this.countryCode = '';
    this.dropdownText = this.defaultText;
    this.class = this.defaultClass;
    this.number = '';
    this.OnChange.emit(null);
  }
}
